// @ts-nocheck
import client from "../../utils/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ResourceReservationCheckinMutationResponse, ResourceReservationCheckinPathParams } from "../models/ResourceReservationCheckin";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ResourceReservationCheckinClient = typeof client<ResourceReservationCheckinMutationResponse, never, never>;
type ResourceReservationCheckin = {
    data: ResourceReservationCheckinMutationResponse;
    error: never;
    request: never;
    pathParams: ResourceReservationCheckinPathParams;
    queryParams: never;
    headerParams: never;
    response: ResourceReservationCheckinMutationResponse;
    client: {
        parameters: Partial<Parameters<ResourceReservationCheckinClient>[0]>;
        return: Awaited<ReturnType<ResourceReservationCheckinClient>>;
    };
};
/**
 * @description Perform check-in for a resource reservation. This operation verifies the user's eligibility, updates the reservation status, and records the check-in time. The system will validate the check-in conditions before processing.
 * @summary Check In to a Resource Reservation
 * @link /api/v5/resource-reservations/:id/checkin
 */
export function useResourceReservationCheckin(options: {
    invalidationOnSuccess?: boolean;
    mutation?: UseMutationOptions<ResourceReservationCheckin["response"], ResourceReservationCheckin["error"], {
        id: ResourceReservationCheckinPathParams["id"];
        data?: ResourceReservationCheckin["request"];
    }>;
    client?: ResourceReservationCheckin["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    const queryClient = useQueryClient();
    let invalidationOnSuccessOption = options?.invalidationOnSuccess ?? true;
    return useMutation({
        mutationFn: async ({ id }) => {
            const res = await client<ResourceReservationCheckin["data"], ResourceReservationCheckin["error"], ResourceReservationCheckin["request"]>({
                method: "patch",
                url: `/api/v5/resource-reservations/${id}/checkin`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions,
        onSuccess: (...args) => {
            if (invalidationOnSuccessOption) {
                queryClient.invalidateQueries({
                    queryKey: ["api", "v5", "resource-reservations"]
                });
            }
            if (mutationOptions?.onSuccess)
                mutationOptions.onSuccess(...args);
        },
    });
}